// src/pages/NotFoundPage.tsx
import React from "react";
import { Text, colors } from "@flexport/latitude-typescript";
import styled from "styled-components";

const NotFoundPage: React.FC = () => {
  return (
    <Container>
      <ContentContainer>
        <NotFoundHeading scale="headline">404 - Page Not Found</NotFoundHeading>
      </ContentContainer>
    </Container>
  );
};

const HORIZONTAL_SPACING_PX = 18;
const GAP_PX = 18;

const Container = styled.div`
  padding: ${GAP_PX}px ${HORIZONTAL_SPACING_PX}px;
  max-width: 960px;
  margin: 0 auto;
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 64px;
`;

const NotFoundHeading = styled(Text)`
  font-weight: 600;
  color: ${colors.grey50};
`;

export default NotFoundPage;
